import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=5d19b569&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=ts&"
export * from "./Content.vue?vue&type=script&lang=ts&"
import style0 from "./Content.vue?vue&type=style&index=0&id=5d19b569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19b569",
  null
  
)

export default component.exports